import { render } from "./ModalContentAIHistory.vue?vue&type=template&id=6e0f9cd6&lang=true"
import script from "./ModalContentAIHistory.vue?vue&type=script&lang=js"
export * from "./ModalContentAIHistory.vue?vue&type=script&lang=js"

import "./ModalContentAIHistory.vue?vue&type=style&index=0&id=6e0f9cd6&lang=css"
script.render = render

export default script